export default __webpack_public_path__ + "static/media/loading-oreo.f56a60bd.png";